"use strict";
var pushNotification = function(posTop, posRight, title, description, type) {
    var message = document.createElement("div");
    message.classList.add("notification", type);
    var h2 = document.createElement("h2");
    h2.textContent = title;
    h2.classList.add("title");
    var descriptionBlock = document.createElement("p");
    descriptionBlock.textContent = description;
    message.style.top = "".concat(posTop, "px");
    message.style.right = "".concat(posRight, "px");
    message.append(h2, descriptionBlock);
    document.querySelector("body").append(message);
    setTimeout(function() {
        message.style.display = "none";
    }, 2000);
};
pushNotification(10, 10, "Title of Success message", "Message example.\n Notification should contain title and description.", "success");
pushNotification(150, 10, "Title of Error message", "Message example.\n Notification should contain title and description.", "error");
pushNotification(290, 10, "Title of Warning message", "Message example.\n Notification should contain title and description.", "warning");

//# sourceMappingURL=index.33ce7ae2.js.map
